<template>
  <div class="page-setting">
    <Navigation title="设置" />
    <div class="setting-item">
      <span class="title">昵称</span>
      <span class="desc">{{userInfo.cnName}}</span>
    </div>
    <div class="setting-item">
      <span class="title">手机号</span>
      <span class="desc">{{getHiddenPhone(userInfo.mobile)}}</span>
    </div>
    <div class="btn-logout" @click="logout">退出登录</div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation'
import LoginService from '@/services/login'
import { mapGetters } from 'vuex'
import { getHiddenPhone } from '@/utils/help'
export default {
  name: 'setting',
  components: {
    Navigation,
  },
  data() {
    return {
      getHiddenPhone: getHiddenPhone,
    }
  },
  computed: {
    ...mapGetters([
      'userInfo', // 个人资料
    ]),
  },
  methods: {
    /**
     * 退出登录
     */
    logout() {
      LoginService.logout()
    },
  },
}
</script>

<style  lang="scss" scoped>
.page-setting {
  position: relative;
  height: 100%;
  background: #f8f8f8;
  .setting-item {
    line-height: 0.9rem;
    padding-left: 0.2rem;
    color: #666;
    background-color: #fff;
    font-size: 0.28rem;
    border-top: 1px solid #eee;
    .title {
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #333;
      font-weight: 700;
    }
    .desc {
      float: right;
      padding-right: 0.42rem;
      color: #666;
      width: 70%;
      text-align: right;
    }
  }
  .btn-logout {
    height: 0.8rem;
    line-height: 0.8rem;
    border-radius: 0.4rem;
    background-image: linear-gradient(to left, #ff1a1a, #fd2b6b);
    font-family: PingFangSC-Regular;
    font-size: 0.28rem;
    color: #fff;
    text-align: center;
    margin: 0.32rem 0.3rem;
    cursor: pointer;
    &:active {
      opacity: 0.5;
    }
  }
}
</style>